import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { BreadcrumbManager } from '@atlassian/jira-breadcrumbs/src/breadcrumb-manager/index.tsx';
import BreadcrumbRenderer from '@atlassian/jira-breadcrumbs/src/breadcrumb-renderer/index.tsx';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb/component.tsx';
import ProjectBreadcrumb from '@atlassian/jira-breadcrumbs/src/common-breadcrumbs/project/index.tsx';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { getProjectSettingsUrl } from '@atlassian/jira-servicedesk-common/src/navigation/settings';
import messages from './messages';

type Props = {
	projectKey: string;
	projectName: string;
};

const PortalSettingsHeader = ({ projectKey, projectName }: Props) => {
	const { formatMessage } = useIntl();
	const { pageTitle, classicPageHeaderOld, classicPageHeader } = messages;

	return (
		<BreadcrumbManager>
			<ProjectBreadcrumb baseUrl="" projectKey={projectKey} projectName={projectName}>
				<Breadcrumb
					breadcrumb={{
						href: getProjectSettingsUrl(projectKey),
						text: formatMessage(pageTitle),
						type: 'portal-settings',
					}}
				/>
				<Box xcss={portalSettingsHeaderWrapperStyles}>
					<PageHeader
						breadcrumbs={
							<Box xcss={breadcrumbWrapperStyles}>
								<BreadcrumbRenderer />
							</Box>
						}
					>
						{formatMessage(
							fg('jsm_simplified_project_settings_navigation')
								? classicPageHeader
								: classicPageHeaderOld,
						)}
					</PageHeader>
				</Box>
			</ProjectBreadcrumb>
		</BreadcrumbManager>
	);
};

export default PortalSettingsHeader;

const breadcrumbWrapperStyles = xcss({
	marginLeft: 'space.negative.050',
});

const portalSettingsHeaderWrapperStyles = xcss({
	paddingLeft: 'space.100',
});
